import { Box, Button, Card, CardContent, Grid, Stack, TextField, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import VerifiedIcon from '@mui/icons-material/Verified';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import LockIcon from '@mui/icons-material/Lock';

/**
 * Placeholder landing for the public marketplace. Tour 6 replaces this
 * with the full search experience. We keep enough to demonstrate the
 * layout/theme working end-to-end.
 */
export function Landing() {
  return (
    <Stack spacing={6}>
      {/* Hero */}
      <Box sx={{ textAlign: 'center', py: { xs: 4, md: 8 } }}>
        <Typography variant="h1" component="h1" sx={{ mb: 2 }}>
          Care that travels with you.
        </Typography>
        <Typography variant="h6" color="text.secondary" fontWeight={400} sx={{ maxWidth: 720, mx: 'auto', mb: 4 }}>
          Verified clinicians. Portable prescriptions. Your record, your wallet.
          Across borders.
        </Typography>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={1.5}
          sx={{ maxWidth: 640, mx: 'auto' }}
        >
          <TextField
            fullWidth
            placeholder="Find a doctor, specialty, or condition"
            InputProps={{ startAdornment: <SearchIcon sx={{ mr: 1, color: 'text.secondary' }} /> }}
          />
          <Button variant="contained" size="large" sx={{ px: 4, whiteSpace: 'nowrap' }}>
            Search
          </Button>
        </Stack>
      </Box>

      {/* Pillars */}
      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <Card sx={{ height: '100%' }}>
            <CardContent>
              <VerifiedIcon color="primary" sx={{ fontSize: 32, mb: 1 }} />
              <Typography variant="h6" gutterBottom>Trust passport</Typography>
              <Typography variant="body2">
                Every clinician carries verifiable credentials —
                you can see exactly which licenses and verifications back the badge.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card sx={{ height: '100%' }}>
            <CardContent>
              <LockIcon color="primary" sx={{ fontSize: 32, mb: 1 }} />
              <Typography variant="h6" gutterBottom>Privacy by default</Typography>
              <Typography variant="body2">
                Your record is encrypted per-patient. Every access is audited.
                You can revoke any consent at any time.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={4}>
          <Card sx={{ height: '100%' }}>
            <CardContent>
              <HealthAndSafetyIcon color="primary" sx={{ fontSize: 32, mb: 1 }} />
              <Typography variant="h6" gutterBottom>AI with humans in charge</Typography>
              <Typography variant="body2">
                Clinical AI helps the clinician — never the other way around.
                Every suggestion is logged and explicitly accepted.
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Stack>
  );
}
